var date = 1,  //ID vybraného data
    currency = 1; //ID vybrané měny



$(".price").click(function (e) {
    showPrice();
    e.stopPropagation();
});

$(".price").one("click", function () {
    $(".price-list-slider").slick({
        slidesToShow: 1,
        infinite: false,
        prevArrow: "<button type='button' class='slick-prev icon-chevron-left'></button>",
        nextArrow: "<button type='button' class='slick-next icon-chevron-right'></button>",
    });
});

function showPrice() {
    $("#price-list").fadeIn("medium");
    $("body").css("overflow", "hidden");
}

function hidePrice() {
    $("#price-list").fadeOut();
    $("body").css("overflow", "auto");
}

$("body").on("click", ".close-price-list, .overlay", function () {
    hidePrice();
});

$("body").on("click", function (event) {

    if($(event.target).closest(".content").length == 0){
        hidePrice();
    }
});

function priceListResize() {
    var vHeight = $(window).height(),
        vWidth = $(window).width(),
        priceList = $('#price-list');

    priceList.css({"height":vHeight,"width":vWidth});
}

priceListResize();

$(window).resize(function () {
    priceListResize();
});

$(".custom-select").click(function () {
    var option = $(this).find(".options"),
        chevron = $(this).find(".icon-chevron-down");

    if(chevron.hasClass("isOpen")){
        chevron.removeClass("isOpen");
    }
    else{
        chevron.addClass("isOpen");
    }

    option.slideToggle();
});


$(".custom-select").find(".option").click(function () {
    var text = $(this).text(),
        id = $(this).attr("data-id");


    $(this).parent().children(".option").removeClass("selected");
    $(this).addClass("selected");

    $(this).parent().siblings(".data").html(text);
    $(this).parent().siblings(".data").attr("data-id", id);

    date = $(".date").attr("data-id");
    currency = $(".currency").attr("data-id");
});
